// Shared framer-motion variants for cinematic reveals
export const EASE = [0.65, 0, 0.35, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE },
  },
};

export const stagger = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

export const maskLine = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 1, ease: EASE, delay: 0.15 * i },
  }),
};

export const viewportOnce = { once: true, amount: 0.15 };

// For tall containers (grids) that can exceed the viewport height on mobile:
// trigger as soon as any part enters, so content never stays hidden.
export const viewportSome = { once: true, amount: "some" };
